<template>
    <PainelGrafico
        titulo="Propostas Comerciais"
        v-model:aberto="mostrarGrafico"
        :carregando="carregando"
        :vazio="!carregando && (!data || !data.length)"
        :dica="mes == null ? 'Clique em um mês para ver as semanas' : 'Clique em uma semana para ver o detalhe'"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 23rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Soma das oportunidades no status "conquistado" por mês.<br>
                        <b>Polaridade:</b> Quanto maior, melhor.<br>
                        <b>Fonte:</b> OMIE > CRM > Oportunidades.<br>
                        <b>Descrição:</b> Quantidade de oportunidades conquistadas no período.
                    </div>
                </v-card>
            </v-menu>
        </template>

        <Bar
            :options="dadosGrafico().options"
            :data="dadosGrafico().data"
            ref="barChart"
        />
    </PainelGrafico>
    <ModalListaPropostaComerciais :lista="lista" v-if="showModal" @fecharModal="showModal = false" />
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import ModalListaPropostaComerciais from '@/components/Modais/ModalListaPropostaComerciais.vue';
import PainelGrafico from '@/components/PainelGrafico.vue';
import { getChartTheme, baseChartOptions } from '@/utils/chartTheme';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'GraficoPropostasComerciais',
    components: {
        ModalListaPropostaComerciais,
        Bar,
        PainelGrafico,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            data: [],
            mostrarGrafico: true,
            carregando: true,
            lista: null,
            showModal: false,
        };
    },
    watch: {
        mes: 'getDados',
        ano: 'getDados',
    },
    mounted() {
        this.getDados();
    },
    methods: {
        async getDados() {
            this.carregando = true;
            try {
                this.data = await serviceGraficos.getPropostasComerciais(this.mes, this.ano);
            } catch (error) {
                console.error('Erro ao obter dados:', error);
                this.data = [];
            } finally {
                this.carregando = false;
            }
        },
        async mostrarLista(semana) {
            this.lista = await serviceGraficos.getListaPropostasComerciais(this.ano + semana);
            this.showModal = true;
        },
        dadosGrafico() {
            const theme = getChartTheme();
            const options = baseChartOptions({
                ...theme,
                onClick: (e) => {
                    if (!this.$refs.barChart?.chart) return;
                    const canvasPosition = getRelativePosition(e, this.$refs.barChart.chart);
                    const dataX = this.$refs.barChart.chart.scales.x.getValueForPixel(canvasPosition.x);
                    if (dataX == null || dataX < 0) return;
                    if (this.mes == null) {
                        this.$emit('updateMes', dataX + 1);
                    } else if (this.data[dataX]) {
                        this.mostrarLista(this.data[dataX].x.slice(0, 2));
                    }
                },
            });

            return {
                data: {
                    datasets: [{
                        label: 'Propostas viabilizadas',
                        backgroundColor: '#3571CD',
                        borderRadius: 4,
                        data: this.data,
                    }],
                },
                options,
            };
        },
    },
};
</script>
